import { PLACEMENTS } from 'store/common/recommendations/constants';

export const DEFAULT_RECOMMENDATION_TAB = PLACEMENTS.LAST_VIEWS;
export const DEFAULT_RECOMMENDATION_TAB_TITLE = 'История просмотров';

export const RECOMMENDATION_TABS = [
  {
    id: DEFAULT_RECOMMENDATION_TAB,
    title: DEFAULT_RECOMMENDATION_TAB_TITLE,
    isActive: false,
  },
  {
    id: PLACEMENTS.ALTERNATIVES,
    title: 'Похожие товары',
    isActive: false,
  },
];
